/**
 * Which version and which shell — asked in both shapes the bridges use.
 *
 * The screen carried a constant, `1.6.0`, written by hand into two files and
 * left there through nine releases. Replacing it with the bridge's own word
 * uncovered the second half of the problem: on Android the bridge exposes a
 * Kotlin `val` annotated `@get:JavascriptInterface`, which reaches the page
 * as the METHOD `getAppVersion()` — the property `appVersion` is undefined
 * there, and every reader of it silently got nothing. iOS injects plain
 * properties. So the phone said «web» inside the app while running 1.8.3
 * (03.09.2026), and any code branching on `platform === 'ios'` was reading
 * undefined on Android — right by luck, since the answer was «not ios».
 *
 * One place knows both shapes. In a browser there is no shell and the build
 * stamps `REACT_APP_VERSION`; with neither, say «web» and lie to nobody.
 */
const ask = (obj, prop, getter) => {
  if (!obj) return null;
  const direct = obj[prop];
  if (direct) return String(direct);
  try { return typeof obj[getter] === 'function' ? String(obj[getter]()) : null; } catch (e) { return null; }
};

export function appVersion(win = typeof window === 'undefined' ? null : window) {
  const native = ask(win && win.VoxioxNative, 'appVersion', 'getAppVersion');
  if (native) return native;
  const stamped = typeof process !== 'undefined' && process.env && process.env.REACT_APP_VERSION;
  return stamped ? String(stamped) : 'web';
}

/** Which shell, if any: «android», «ios», or «web» in a browser. */
export function appPlatform(win = typeof window === 'undefined' ? null : window) {
  return ask(win && win.VoxioxNative, 'platform', 'getPlatform')
    || (win && win.__VOXIOX_PLATFORM__ ? String(win.__VOXIOX_PLATFORM__) : null)
    || 'web';
}

/** True on iOS, where several call paths behave differently (CallKit, LinPhone). */
export function isIOS(win = typeof window === 'undefined' ? null : window) {
  return appPlatform(win) === 'ios';
}
